import React from "react";
import { Page, Text, Spinner } from "@shopify/polaris";
import { useEnsureInstall } from "../hooks/useEnsureInstall";

/**
 * Install gate — widgets/settings load once in AppSessionProvider (not per route).
 */
export default function InstallGate({ children }) {
  const { installLoading, isRedirecting, isReady, installError } = useEnsureInstall();

  if (isRedirecting) {
    return (
      <Page>
        <div
          className="age-install-gate-loading"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            minHeight: "min(75vh, 640px)",
            width: "100%",
            boxSizing: "border-box",
            padding: "24px",
          }}
        >
          <Spinner accessibilityLabel="Loading" size="large" />
          <Text as="p" tone="subdued">
            Redirecting to install the app…
          </Text>
        </div>
      </Page>
    );
  }

  if (installLoading || (!isReady && !isRedirecting && !installError)) {
    return (
      <Page>
        <div
          className="age-install-gate-loading"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            minHeight: "min(75vh, 640px)",
            width: "100%",
            boxSizing: "border-box",
            padding: "24px",
          }}
        >
          <Spinner accessibilityLabel="Loading" size="large" />
        </div>
      </Page>
    );
  }

  if (!isReady && !isRedirecting) {
    return (
      <Page>
        <div style={{ padding: "16px" }}>
          <Text as="p" tone="critical">
            {installError || "Checking installation…"}
          </Text>
        </div>
      </Page>
    );
  }

  return children;
}
